import axios from 'axios'

export const fetchPackageInventory = ({ leg, date, time = '' }) =>
  axios({
    method: 'get',
    url: `/api/sailPackage/inventory/${leg}/${date}/${time}`,
  })
